// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Usp_wrapper__WWkut","texts":"Usp_texts__iZ2bf","usp":"Usp_usp__XGdGI","partners":"Usp_partners__4rENc"};